import e from "react";
import { j as r } from "./jsx-runtime-Bdg6XQ1m.js";
import { u as l, L as m } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
const c = {}, u = e.createContext(c);
function f(t) {
  const n = e.useContext(u);
  return e.useMemo(
    function() {
      return typeof t == "function" ? t(n) : { ...n, ...t };
    },
    [n, t]
  );
}
function h(t) {
  let n;
  return t.disableParentContext ? n = typeof t.components == "function" ? t.components(c) : t.components || c : n = f(t.components), e.createElement(
    u.Provider,
    { value: n },
    t.children
  );
}
const y = (t) => {
  const n = l(), o = typeof t.to == "string" ? t.to : t.to.hash, i = (a) => {
    var s;
    !(o != null && o.startsWith("#")) || o !== n.hash || (a.preventDefault(), (s = document.getElementById(o.slice(1))) == null || s.scrollIntoView());
  };
  return /* @__PURE__ */ r.jsx(m, { onClick: i, ...t });
};
export {
  y as A,
  h as M,
  f as u
};
//# sourceMappingURL=AnchorLink-bObQitZv.js.map
